import { useMutation } from '@apollo/client'
import {
  DuplicateProcessDocument,
  DuplicateProcessMutation,
  GetProcessesDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

export type Process = NonNullable<
  DuplicateProcessMutation['processesMutations']['duplicateProcessesProcess']
>['process']

export const useDuplicateProcess = () => {
  const [executeMutation] = useMutation(DuplicateProcessDocument)
  const duplicateProcess = useUnsafeCallback(
    async (id: number, name: string, description?: string) => {
      const { data, errors } = await executeMutation({
        variables: {
          id,
          name,
          description,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetProcessesDocument,
          },
        ],
      })

      const newProcessId = data?.processesMutations?.duplicateProcessesProcess?.process?.id

      if (
        !newProcessId ||
        errors?.length ||
        data.processesMutations?.duplicateProcessesProcess?.errors.length
      ) {
        throw (
          'Could not duplicate process: ' +
          JSON.stringify([
            ...(errors || []),
            ...(data?.processesMutations?.duplicateProcessesProcess?.errors || []),
          ])
        )
      }

      return { id: newProcessId }
    },
    [executeMutation]
  )

  return {
    duplicateProcess,
  }
}
